var _rect, _line, _line2, _line3, _line4, _line5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterfall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.377451,
    y: 0.377451,
    width: 119.245,
    height: 99.2451,
    rx: 3.62255,
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 0.754902
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 9.75,
    x2: 110,
    y2: 9.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 29.75,
    x2: 110,
    y2: 29.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 49.75,
    x2: 110,
    y2: 49.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 69.75,
    x2: 110,
    y2: 69.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 89.75,
    x2: 110,
    y2: 89.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 11,
    height: 80,
    fill: "#7335CB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 10,
    width: 10,
    height: 32,
    fill: "#8CD6A0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 25,
    width: 11,
    height: 17,
    fill: "#496DFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 10,
    width: 12,
    height: 15,
    fill: "#7335CB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 25,
    width: 11,
    height: 35,
    fill: "#8CD6A0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19,
    transform: "matrix(1 0 0 -1 81 60)",
    fill: "#496DFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 41,
    width: 10,
    height: 36,
    fill: "#7335CB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfall);
export default __webpack_public_path__ + "static/media/waterfall.b0c28a174b471dc6c8b74acd9a33f37d.svg";
export { ForwardRef as ReactComponent };